export const initialFilter = {
  filter: {
    paramsName: "",
  },
  pageNumber: 1,
  pageSize: 500,
};
